import { DOCUMENT } from '@angular/common';
import { Component, Inject, Renderer2, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, Meta, SafeHtml, Title } from '@angular/platform-browser';
import { SiteInfo } from '../../models/blog';
import { PageMeta } from '../../models/page-meta';
import { ReplaceMetaDatePipe } from '../../pipes/replace-meta-date.pipe';
import { PagesApiService } from '../../services/pages-api.service';

@Component({
  selector: 'app-privacy-policy',
  imports: [],
  templateUrl: './privacy-policy.component.html',
  styleUrl: './privacy-policy.component.css',
  encapsulation: ViewEncapsulation.None
})
export class PrivacyPolicyComponent {
  pendingCalls: number = 0;
  isDataLoaded: boolean = false;
  privacyHtmlContent!: SafeHtml;
  siteInfos: SiteInfo[] = [];
  today = new Date();
  pagemeta: PageMeta[] = [];

  constructor(
    private siteApi: PagesApiService,
    private meta: Meta,
    private title: Title,
    private replaceMetaPipe: ReplaceMetaDatePipe,
    @Inject(DOCUMENT) private dom: Document,
    private renderer: Renderer2,
    private sanitizer: DomSanitizer
  ) {
    this.loadAllData();
  }

  loadAllData() {
    this.pendingCalls = 2;
    this.getSiteInfos();
    this.getPageMeta();
  }

  checkIfAllDone() {
    this.pendingCalls--;
    if (this.pendingCalls === 0) {
      this.isDataLoaded = true;
    }
  }

  public loadScript(url: string) {
    const body = <HTMLDivElement>document.body;
    const script = document.createElement('script');
    script.innerHTML = '';
    script.src = url;
    script.async = false;
    script.defer = true;
    body.appendChild(script);
  }

  updateMetaData(data: PageMeta) {
    const pageTitle = this.replaceMetaPipe.transform(data.PageTitle!);
    const pageDescription = this.replaceMetaPipe.transform(data.PageDescription!);
    const pageUrl = `https://www.dealszo.com/privacy/`;
    // const keyWords = data.PageKeywords!;

    // Update the title and meta tags dynamically
    this.title.setTitle(pageTitle);
    this.meta.updateTag({ name: 'title', content: pageTitle });
    this.meta.updateTag({ name: 'description', content: pageDescription });
    // this.meta.updateTag({
    //   name: 'keywords',
    //   content: keyWords,
    // });

    this.meta.updateTag({
      name: 'robots',
      content:
        'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1',
    });

    // Open Graph meta tags
    this.meta.updateTag({ property: 'og:type', content: 'website' });
    this.meta.updateTag({ property: 'og:site_name', content: 'dealszo.com' });
    this.meta.updateTag({ property: 'og:title', content: pageTitle });
    this.meta.updateTag({
      property: 'og:description',
      content: pageDescription,
    });
    // this.meta.updateTag({ property: 'og:image', content: imageUrl });
    this.meta.updateTag({ property: 'og:url', content: pageUrl });

    let link: HTMLLinkElement = this.dom.querySelector(
      `link[rel='canonical']`
    )!;
    let alternativeLink: HTMLLinkElement = this.dom.querySelector(
      `link[rel='alternate']`
    )!;
    if (link) {
      this.renderer.setAttribute(link, 'href', pageUrl);
    } else {
      link = this.renderer.createElement('link');
      this.renderer.setAttribute(link, 'rel', 'canonical');
      this.renderer.setAttribute(link, 'href', pageUrl);
      this.renderer.appendChild(this.dom.head, link);
    }
    if (alternativeLink) {
      this.renderer.setAttribute(alternativeLink, 'href', pageUrl);
    } else {
      link = this.renderer.createElement('link');
      this.renderer.setAttribute(alternativeLink, 'rel', 'canonical');
      this.renderer.setAttribute(alternativeLink, 'href', pageUrl);
      this.renderer.appendChild(this.dom.head, link);
    }

    if (data.PageSchema && data.PageSchema.trim() !== '') {
      const schema = this.replaceMetaPipe.transform(data.PageSchema);
      const jsonLdScripts = this.dom.head.querySelectorAll(
        'script[type="application/ld+json"]'
      );
      jsonLdScripts.forEach(script => script.remove());
      const temp = this.dom.createElement('div');
      temp.innerHTML = schema;
      const scripts = temp.querySelectorAll(
        'script[type="application/ld+json"]'
      );
      scripts.forEach((scriptTag, index) => {
        const newScript = this.dom.createElement('script');
        newScript.type = 'application/ld+json';
        newScript.id = `schema-jsonld-${index}`;
        newScript.text = scriptTag.textContent || '';
        this.dom.head.appendChild(newScript);
      });
    }
  }

  getSiteInfos() {
    this.siteApi.getSiteInfo().subscribe((data) => {
      if (data.Message === 'Data Fetched Successfully!!!') {
        this.siteInfos = data.Data;
        let html = this.siteInfos.find(
          (s) => s.InfoId == 1
        )!.PageContent;
        html = this.replaceMetaPipe.transform(html!);
        this.privacyHtmlContent = this.sanitizer.bypassSecurityTrustHtml(html);
      } else {
      }
      this.checkIfAllDone();
    });
  }

  getPageMeta() {
    this.siteApi.getPagesMeta().subscribe((data) => {
      if (data.Message === 'Data Fetched Successfully!!!') {
        this.pagemeta = data.Data;
        this.updateMetaData(
          this.pagemeta.find((p) => p.PageName?.includes('privacy'))!
        );
      } else {
      }
      this.checkIfAllDone();
    });
  }
}
